module.exports = __webpack_public_path__ + "static/img/Young_Queenz.d1269a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Young_Queenz.jpg
// module id = 48Qo
// module chunks = 1